import DataTable from '../../components/DataTable.jsx';
import { number, percent } from '../../utils/format.js';

// The year-by-year metrics table is MANDATORY on every backtest result per
// docs/mystocks/OBT_INTEGRATION_SPEC.md §1 ("year-by-year + overall metrics
// are MANDATORY on every result — that table is the contract").
const COLUMNS = [
  { key: 'year', header: 'Year' },
  {
    key: 'return',
    header: 'Return',
    numeric: true,
    render: (r) => (
      <span className={r.return >= 0 ? 'aq-num-gain' : 'aq-num-loss'}>
        {percent(r.return, true)}
      </span>
    ),
  },
  { key: 'sharpe', header: 'Sharpe', numeric: true, render: (r) => number(r.sharpe) },
  {
    key: 'maxDrawdown',
    header: 'Max drawdown',
    numeric: true,
    render: (r) => <span className="aq-num-loss">{percent(r.maxDrawdown)}</span>,
  },
  { key: 'trades', header: 'Trades', numeric: true },
];

export default function YearlyMetricsTable({ rows }) {
  return (
    <DataTable
      columns={COLUMNS}
      rows={(rows || []).map((r) => ({ ...r, id: r.year }))}
      emptyLabel="No year-by-year data yet."
    />
  );
}
